import { Actions, ActionTypes } from './actions';


export interface State {
    modalOpen: boolean;
    isLoading: boolean;
    error: boolean;
}

export const initialState: State = {
    modalOpen: false,
    isLoading: false,
    error: false,
};

export function reducer(state: State = initialState, action: Actions) {
    switch (action.type) {
        case ActionTypes.OpenEditModal:
            return {
                ...state,
                modalOpen: true,
            };

        case ActionTypes.CloseEditModal:
            return {
                ...state,
                modalOpen: false,
            };

        case ActionTypes.EditCustomerCompany:
            return {
                ...state,
                isLoading: true,
            };

        case ActionTypes.FetchEditCustomerCompanyResponse:
            return {
                ...state,
                modalOpen: false,
                isLoading: false,
                error: false,
            };

        default:
            return state;

    }
}
